"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canDeliverByClickAndCollect = void 0;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const canDeliverByClickAndCollect = (logisticRoute) => logisticRoute === module_logistic_interfaces_1.LogisticRoute.ClickAndCollect || logisticRoute === module_logistic_interfaces_1.LogisticRoute.StoreDelivery;
exports.canDeliverByClickAndCollect = canDeliverByClickAndCollect;
